import React from "react";
import { PeekTooltip, PeekTypography } from "@piiqtechnologies/ui-components";
const underlineSx = {
    textDecoration: "underline",
    textDecorationStyle: "dotted",
    textUnderlineOffset: "3px",
    cursor: "help",
};
export const UnderlinedTooltip = ({ tooltip, children, placement = "top", typographyProps, sx, onOpen, }) => {
    const tooltipNode = typeof tooltip === "string" ? React.createElement(PeekTypography, { variant: "body1" }, tooltip) : tooltip;
    const mergedSx = Object.assign(Object.assign({}, underlineSx), sx);
    return (React.createElement(PeekTooltip, { placement: placement, title: tooltipNode, onOpen: onOpen },
        React.createElement(PeekTypography, Object.assign({}, typographyProps, { sx: mergedSx }), children)));
};
export default UnderlinedTooltip;
